/**
 * @fileoverview Helper functions that operate on the genre hierarchy data.
 */

import type { GenreTemplate } from '@/domains/style-guides/schemas';
import { styleGuideHierarchy } from './genres';

/**
 * Gets a flattened catalog of all genre templates for UI components.
 * @returns An array of objects containing genre metadata.
 */
export function getGenreCatalog(): { value: string; label: string; category: string; }[] {
    return Object.entries(styleGuideHierarchy).flatMap(([category, details]) =>
        details.templates.map(template => ({
            value: template.templateId,
            label: template.name,
            category: category,
        }))
    );
}

/**
 * Gets the metadata for a specific genre template by its ID.
 * @param templateId The unique ID of the genre template.
 * @returns The template metadata object or undefined if not found.
 */
export function getGenreTemplateById(templateId: string): GenreTemplate | undefined {
    for (const category in styleGuideHierarchy) {
        const template = styleGuideHierarchy[category].templates.find(t => t.templateId === templateId);
        if (template) return template;
    }
    return undefined;
}
